import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { alpha } from "@material-ui/core/styles/colorManipulator";

//this exists because you can only select primary or secondary as button colours in material v4
//it also removes the shadows and rounded corners on all buttons without needs global css

const useStyles = makeStyles(theme => ({
    customButton: {
        borderRadius: theme.spacing(0.3),
        textTransform: "none",
        boxShadow: "none",
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        fontSize: "1rem",
        marginRight: theme.spacing(0.5)
    },
    textTertiary: {
        color: theme.palette.tertiary.main,
        "&:hover": {
            backgroundColor: alpha(
                theme.palette.tertiary.main,
                theme.palette.action.hoverOpacity
            ),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    },
    outlinedTertiary: {
        color: theme.palette.tertiary.main,
        border: `1px solid ${alpha(theme.palette.tertiary.main, 0.5)}`,
        "&:hover": {
            border: `1px solid ${theme.palette.tertiary.main}`,
            backgroundColor: alpha(
                theme.palette.tertiary.main,
                theme.palette.action.hoverOpacity
            ),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    },
    containedTertiary: {
        color: theme.palette.tertiary.contrastText,
        backgroundColor: theme.palette.tertiary.main,
        "&:hover": {
            backgroundColor: theme.palette.tertiary.dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.palette.tertiary.main
            }
        }
    }
}));

const CustomButton = React.forwardRef(function({ variant = "text", color, className, ...other }, ref){
    const classes = useStyles();
    return (
        <Button
            {...other}
            variant={variant}
            color={color === "tertiary" ? "primary" : color}
            className={clsx(className, {
                [classes.customButton]: true,
                [classes[variant+'Tertiary']]: color === "tertiary"
            })}
            ref={ref}
        />
    );
});
export default CustomButton;